import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useGetPrivacyPolicyQuery } from "../../Services/SettingsService";
// Loads the CSS for Quill's ".ql-*" formatting classes (align/indent/size/font,
// plus base heading & list styles) that the Admin CMS editor emits, so the
// formatting applied in Admin renders identically here.
import "react-quill/dist/quill.snow.css";
// Restores heading font-weight (Quill only restores font-size; Tailwind's
// Preflight strips the browser's native heading bold, see file for detail).
import "../../styles/quillContent.css";

const PrivacyPolicy = () => {
  const { data, isLoading, isError } = useGetPrivacyPolicyQuery({});
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);
  return (
    <div className={`bg-white dark:bg-dark-background py-8 md:px-20 px-0`}>
      <h1 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">
        Privacy Policy
      </h1>

      {/* A plain <p> is invalid here (Quill's HTML contains block elements
          like <h1>/<ol>/<blockquote>, which the browser would prematurely
          close a <p> around); the "ql-editor" class is required for Quill's
          format CSS (imported above) to actually apply.
          The "ql-snow" wrapper is required too: Quill's heading sizes
          (h1-h6) are only defined as ".ql-snow .ql-editor h1" etc. — without
          this ancestor class those rules never match, and headings
          silently fall back to plain, unstyled text. */}
      <div className="ql-snow">
        <div
          // The stored content uses inline `color: var(--text-primary|secondary|link)`
          // styles that don't resolve to anything here (those custom properties
          // aren't defined in this app), so that text falls back to inheriting
          // THIS container's color. Match the page's own heading shade
          // (text-gray-900/white) rather than a lighter gray, so the inherited
          // text reads as dark/"bright" as it does in Admin instead of looking
          // washed out.
          className="ql-editor !h-auto !overflow-visible !p-0 text-gray-900 dark:text-white"
          dangerouslySetInnerHTML={{
            __html: data && data?.length > 0 && data[0].policycontent,
          }}
        />
      </div>
    </div>
  );
};

export default PrivacyPolicy;
